<template>
  <div class="GuidePageWrap">
    <!-- logo -->
    <div class="logo">
      <img src="static/img/logo.png" />
    </div>
    <div class="mainBox">
      <!-- 越极限 -->
      <div class="sloganBox">
        <img src="../assets/image/GuidePage_txt.png" class="textImg1" />
      </div>
      <!-- 文字 -->
      <div class="mainText">
        <img src="../assets/image/GuidePage_text.png" class="textImg2" />
        <!-- <p>中国 • 上海（香格里拉大酒店）</p> -->
        <!-- <p style="margin-top: 0.1rem;">2021年4月18-20日</p> -->
      </div>
    </div>
  </div>
</template>

<script>
  export default{
    name: 'GuidePage',
  }
</script>

<style scoped>
  .GuidePageWrap{
    width: 100%;
    background: url(../assets/image/GuidePage4.jpg);
    background-size: 100% 100%;
    overflow: hidden;
    min-height: 100%;
  }
  .GuidePageWrap img{
    width: 100%;
    height: auto;
  }
  .logo{
    width: 90%;
    margin: .5rem auto 1.12rem;
  }
  .mainBox{
    width: 100%;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    top: 53%;
  }
  .sloganBox{
    width: 80%;
    height: 2.48rem;
    overflow: hidden;
    margin: 0 auto;
    text-align: center;
    background: url(../assets/image/Guide_line.png) no-repeat;
    background-size: cover;
  }
  .sloganBox img{
    margin-top: .2rem;
  }
  .mainText {
    width: 2.84rem;
    height: .73rem;
    overflow: hidden;
    margin: 15% auto 0;
    text-align: center;
    /* color: #FFFFFF; */
    /* font-size: 0.3rem; */
  }
  .textImg1{
    animation: fadeInUp 2.5s ease-in-out;
    -moz-animation: fadeInUp 2.5s ease-in-out;
    /* Firefox */
    -webkit-animation: fadeInUp 2.5s ease-in-out;
    /* Safari 和 Chrome */
    -o-animation: fadeInUp 2.5s ease-in-out;
    /* Opera */
  }
  .textImg2{
    animation: fadeInUp 3s ease-in-out;
    -moz-animation: fadeInUp 3s ease-in-out;
    /* Firefox */
    -webkit-animation: fadeInUp 3s ease-in-out;
    /* Safari 和 Chrome */
    -o-animation: fadeInUp 3s ease-in-out;
    /* Opera */
  }
  @-webkit-keyframes fadeInUp {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(0, 100%, 0);
      transform: translate3d(0, 100%, 0);
    }

    100% {
      opacity: 1;
      -webkit-transform: none;
      transform: none;
    }
  }

  @keyframes fadeInUp {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(0, 100%, 0);
      transform: translate3d(0, 100%, 0);
    }

    100% {
      opacity: 1;
      -webkit-transform: none;
      transform: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/GuidePage.vue